import { Image, Swiper } from 'antd-mobile-v5'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import AllCardsList from './AllCardsList'
import BuyOptions from './BuyOptions'
import { useCardOptions } from '../../services/hooks'
import LoadingStatus from '../../components/FormTools/Loading'
import PublicWelfareIntro from './components/PublicWelfareIntro'
import StoryPopup from './components/StoryPopup'
import { getMinPriceOptions } from './cardOptionUtils'
import { UClick } from '../../components/common/utils'
import { cardStories } from '../../utils/cardStories'
import { loadEcards } from '../../actions'
import { getUserInfo } from '../../reducers/selectors'

import styles from './BuyCards.module.css'

export default () => {
  const { push, replace } = useHistory()
  const dispatch = useDispatch()
  const userInfo = useSelector(getUserInfo)
  const previewTracked = useRef(false)
  const [cardOptions, setCardOptions] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [selectedImage, setSelectedImage] = useState('')
  const [isPlastic, setIsPlastic] = useState(true)
  const [currentStory, setCurrentStory] = useState(null)
  const [showAllCards, setShowAllCards] = useState(false)
  const [storyVisible, setStoryVisible] = useState(false)
  const [defaultIndex] = useState(0)

  const { loading, data } = useCardOptions({
    ready: true,
    noDialog: true,
    onSuccess: (data) => {
      let minPriceOptions = getMinPriceOptions(data)
      minPriceOptions.forEach((option, index) => {
        option.id = index
      })
      setSelectedImage(minPriceOptions[0].styleName)
      setCardOptions(minPriceOptions)
    },
  })

  useEffect(() => {
    dispatch(loadEcards())
  }, [dispatch])

  useEffect(() => {
    if (userInfo) {
      replace('/buy_cards')
    } else if (!userInfo && !previewTracked.current) {
      previewTracked.current = true
      UClick('buyCardsPreview')
    }
  }, [userInfo, replace])

  useEffect(() => {
    setCurrentStory(null)
    const story = cardStories.find(
      (s) => cardOptions[selectedIndex]?.cardStockId && s.id === cardOptions[selectedIndex].cardStockId
    )
    if (story) {
      setCurrentStory(story)
    }
  }, [selectedIndex, cardOptions])

  const toggleCard = useCallback(
    (index) => {
      setSelectedIndex(index)
      setSelectedImage(cardOptions[index]?.styleName || '')
      setIsPlastic(true)
    },
    [cardOptions]
  )

  const hasStoryCard = useCallback((styleName) => {
    return cardStories.find((story) => story.name.indexOf(styleName) >= 0)
  }, [])

  const toSelectCert = useCallback(() => {
    UClick('buyCardsPreviewSelectCert')
    push('/emailLogin?referer=%2Fbuy_cards%3Fsrc%3Dpreview&src=preview')
  }, [push])

  if (loading || !data) return <LoadingStatus />

  return (
    <div className={styles.container}>
      <div className={styles.flexible}>
        <Image src={require('../../assets/images/buy_cards/banner3.png')} lazy />
        <div className={styles['card-options']}>
          <div className={styles['options-header']}>
            <div className={styles.title}>卡面选择</div>
            <div className={styles.extra} onClick={() => setShowAllCards(true)}>
              查看所有卡片
            </div>
          </div>
          <div className={styles.options}>
            <Swiper
              defaultIndex={defaultIndex}
              key={defaultIndex}
              trackOffset={10}
              slideSize={80}
              indicator={() => null}
              onIndexChange={toggleCard}
            >
              {cardOptions.map((option, index) => {
                const story = hasStoryCard(option.styleName)
                return (
                  <Swiper.Item className={styles['option-item']} key={index}>
                    <div className={styles['card-wrapper']}>
                      <div style={{ paddingBottom: '65.79%', position: 'relative' }}>
                        <img src={option.imageUrl} className={styles.card} alt="card" />
                      </div>
                      <div className={styles.content}>
                        <div className={styles['card-name']}>{option.styleName}</div>
                        {story && (
                          <div className={styles['story-box']} onClick={() => setStoryVisible(true)}>
                            <img
                              src={require(
                                `../../assets/images/buy_cards/${story.author.imgName || 'default-author'}.png`
                              )}
                              alt="avator"
                              className={styles.avator}
                            />
                            <div className={styles['story-detail']}>了解卡面故事</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Swiper.Item>
                )
              })}
            </Swiper>
          </div>
        </div>
        <div className={styles['options-box']}>
          <BuyOptions
            selectedImage={selectedImage}
            isPlastic={isPlastic}
            setIsPlastic={setIsPlastic}
            previewOnly={true}
          />
        </div>
        <AllCardsList visible={showAllCards} setVisible={setShowAllCards} cardOptions={cardOptions} />
        {currentStory && <StoryPopup visible={storyVisible} setVisible={setStoryVisible} story={currentStory} />}
        <PublicWelfareIntro />
      </div>
      <div className={styles.bottom}>
        <div className={styles.right} style={{ width: '100%', margin: '0 12px', padding: '11px 0' }}>
          <button className={styles['buy-btn']} style={{ width: '100%' }} onClick={toSelectCert}>
            选择证书，立即购买
          </button>
        </div>
      </div>
    </div>
  )
}
